import { Box } from "@mui/material";
import { v2 } from "../ui/v2Tokens";
import { bandTone } from "../ui/bandTone";
import type { DayBand } from "../builder/targetsMath";

const BANDS: DayBand[] = ["ok", "warn", "over", "under"];

/**
 * What the tints mean, spelled out — including the numbers.
 *
 * The `ok` swatch carries "עד ±7% מהיעד" because a band nobody can see the rule for is folklore: a
 * trainer would otherwise have to infer where amber starts from the cells in front of them, and
 * would infer it differently each month.
 */
const MonthLegend = () => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: "6px 14px",
      paddingTop: "10px",
      fontSize: "11px",
      color: v2.ink3,
    }}
  >
    {BANDS.map((band) => (
      <Box key={band} sx={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "3px",
            background: bandTone[band].fill,
            border: `1px solid ${v2.line}`,
            flex: "none",
          }}
        />
        {bandTone[band].label}
      </Box>
    ))}
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "3px",
          background: v2.surface,
          border: `1px dashed ${v2.line}`,
          flex: "none",
        }}
      />
      לא דווח
    </Box>
  </Box>
);

export default MonthLegend;
